import { experiences } from '../../../data';
import ExpeCart from '../../../views/carts/expeCart/ExpeCart';
import ListView from './ListView';

export default function Experience() {
  return (
    <div className="flex flex-wrap flex-col lg:flex-row">
      {experiences?.map((item) => (
        <div className="w-full p-3 group relative">
          <ExpeCart item={item} />
          <div className="bg-primary-800 z-10 hidden absolute shadow-inner shadow-primary-300 p-4 group-hover:block">
            <h2 className="mb-4 text-center">Responsibilities</h2>

            <ListView list={item.responsibilities} />
          </div>
        </div>
      ))}
    </div>
  );
}
